import React from 'react';
import MaskedInput from 'react-text-mask';

interface CustomTextMaskInputProps {
  inputRef: (ref: HTMLInputElement | null) => void;
}

export const CustomTextMaskInput = React.forwardRef<HTMLElement, CustomTextMaskInputProps>(
  (props) => {
    const { inputRef, ...other } = props;

    const phoneMask = [
      '(',
      /[1-9]/,
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];

    return (
      <MaskedInput
        {...other}
        ref={(element: MaskedInput | null) => {
          if (element && inputRef) {
            inputRef(element.inputElement as HTMLInputElement);
          } else if (inputRef) {
            inputRef(null);
          }
        }}
        mask={phoneMask}
        placeholderChar={'_'}
        showMask={false}
      />
    );
  },
);
